<form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
    <h4>Detalle del contenido de actualidad</h4>
    <div *ngIf="movesLog" class="p-3 mb-3 rounded" style="background-color: #f8f9fa; border: 1px solid #dee2e6;">
        <div class="form-group row">
            <label class="col-md-2 col-form-label">Creado</label>
            <div class="col-md-4">
                <p class="form-control-plaintext text-left">
                    {{ movesLog['creationLog']?.nameUser
                    ? (movesLog['creationLog']?.nameUser + ' - ' + (movesLog['creationLog']?.createdAt |
                    date:'dd/MM/yyyy HH:mm'))
                    : 'No se cuenta con registros del creador.' }}
                </p>
            </div>
            <label class="col-md-2 col-form-label">Editado</label>
            <div class="col-md-4">
                <p *ngIf="movesLog['editLog']" class="form-control-plaintext text-left">
                    {{ movesLog['editLog']?.nameUser }} - {{ movesLog['editLog']?.updatedAt | date:'dd/MM/yyyy
                    HH:mm' }}
                </p>
                <p *ngIf="!movesLog['editLog']" class="form-control-plaintext text-left text-muted">
                    No se cuenta con registros de modificaciones.
                </p>
            </div>
        </div>
    </div>
    <hr>
    <div class="form-group row">

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Contenido</label>
            <textarea class="form-control" placeholder="Contenido" formControlName="content"
                [class.is-invalid]="campoNoValido('content')" rows="6"></textarea>
            <small class="text-danger" *ngIf="campoNoValido('content')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Orden</label>
            <input class="form-control" type="text" placeholder="Orden" formControlName="order" autocomplete="off"
                [class.is-invalid]="campoNoValido('order')">
            <small class="text-danger" *ngIf="campoNoValido('order')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Estado</label>
            <div class="label-container align-switch">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="switch1" formControlName="status">
                </div>
            </div>
        </div>

    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
                <div>
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </div>
            </div>
        </div>
    </div>

</form>